import * as _ from 'underscore';
import React from 'react';
import ReactDom from 'react-dom';
import ReactPlayer from 'react-player';

import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';

import { FormHelperText } from 'material-ui';

import DropSimple from './DropSimple';
import Drop from './Drop';
import MDTag from './MegaDrop/MegaDropTag';
import TextArea from './TextArea';

import * as DesignerState from '../../../state/reducer/designer/designer';
import { paramTypes, workoutParamTypes } from '../../../lib/paramTypes';

import Console from '../../../lib/debug';

const MAX_EXERCISE_POINTS_OF_PERFORMANCE_LENGTH = 10000;

export class ExerciseCreateEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        return {
            titleUsed: false,
            disableButtons: false,
            hasVideoError: false
        };
    };

    clearState = () => {
        this.setState(this.getInitialState());
    };

    componentDidMount() {
        let defaults = {
            eType: 'e',
            param_1_type: workoutParamTypes.REPS,
            param_2_type: workoutParamTypes.WEIGHT,
            points_of_performance: '',
            video_url: '',
            tags: [],
            reference_max_exercise_id: null
        };
        // eslint-disable-next-line
        this.setState(() => ({
            ...defaults,
            ...this.props.exercise
        }));
    }

    disableButtons = () => {
        let newState = {
            ...newState,
            disableButtons: false
        };
        this.setState(() => newState);
    };

    handleChange = async (key, e) => {
        let value = e.currentTarget.value;
        let newState = {
            [key]: value,
            titleUsed: false
        };
        if (key === 'title') {
            let titleUsed = this.isTitleUsed(value);
            if (titleUsed) {
                newState = {
                    ...newState,
                    titleUsed
                };
            }
        }
        if (key === 'video_url') {
            newState = { ...newState, hasVideoError: false };
        }
        this.setState(() => newState);
    };

    handleChangeTags(tags) {
        this.setState(() => ({
            tags
        }));
    }

    handleParameterChange(type, item) {
        this.setState(() => ({
            [`param_${type}_type`]: item ? item.id : null
        }));
    }

    handleReferenceMaxExerciseChange(exercise) {
        let exerciseId = exercise ? exercise.id : null;
        this.setState(() => ({
            reference_max_exercise_id: exerciseId
        }));
    }

    handleReportingExerciseChange(exercise) {
        let exerciseId = exercise ? exercise.id : null;
        this.setState(() => ({
            trainheroic_reference_exercise_id: exerciseId
        }));
    }

    handleSave() {
        for (var i = 0; i < this.state.tags.length; i++) {
            if (typeof this.state.tags[i].id !== 'number') {
                for (var j = 0; j < this.props.tagList.length; j++) {
                    if (
                        this.props.tagList[j].title == this.state.tags[i].title
                    ) {
                        this.state.tags[i] = this.props.tagList[j];
                    }
                }
            }
        }

        this.props.onSave(this.state);
        this.clearState();
    }
    handleClose() {
        this.props.onClose();
        this.clearState();
    }

    getVideoPlayer(videoUrl, width = '100%', height = '100%') {
        if (this.state.hasVideoError) {
            return (
                <div className="invalidVideo">
                    <Typography variant="body1" style={{ color: 'black' }}>
                        URL is invalid or not supported.
                    </Typography>
                    <VideocamOffIcon style={{ color: 'black' }} />
                </div>
            );
        }
        const isYoutubeShort = videoUrl.includes('youtube.com/shorts/');
        const aspectRatio = isYoutubeShort ? '9/16' : '16/9';
        return (
            <ReactPlayer
                className="exerciseVideoPlayer"
                url={videoUrl}
                controls={true}
                muted
                width={width}
                height={height}
                style={{ aspectRatio }}
                onError={() => {
                    console.error(`Error loading video: ${videoUrl}`);
                    this.setState(() => ({ hasVideoError: true }));
                }}
            />
        );
    }

    getNoVideoContent() {
        return (
            <div className="noVideo">
                <Typography variant="body1">No Video.</Typography>
                <VideocamOffIcon />
            </div>
        );
    }

    isTitleUsed = searchTitle => {
        const exerciseRef = this.props.exerciseRef;
        const lowerCaseSearchTitle = searchTitle.toLowerCase().trim();
        const CollisionSearch = exercise => {
            return (
                exercise.user_id !== 0 &&
                exercise.title.toLowerCase() === lowerCaseSearchTitle
            );
        };
        let existingExercise = _.find(exerciseRef, CollisionSearch);
        return !!existingExercise;
    };

    lockEvents = () => {
        this.setState(() => ({
            disableButtons: true
        }));
    };

    onNewCircuitExerciseTag(tag) {
        // Create tag if its not created
        let tags = [...this.state.tags];
        if (typeof tag.id !== 'number') {
            DesignerState.createTag(tag.title);
        }
        tag.id = 'updated';
        tags.push(tag);
        this.setState(() => ({
            tags
        }));
    }

    scrollToBottom = () => {
        this.setState(() => ({
            disableButtons: true
        }));
        const node = ReactDom.findDOMNode(this.bottomDrawer);
        node.scrollIntoView({ behavior: 'smooth' });
    };

    workoutItems(type) {
        let exercise = Object.keys(this.state).length
            ? this.state
            : this.props.exercise;
        let isEditable = exercise.can_edit === 1 || exercise.can_edit === null;
        if (type === 'e') {
            let videoContent = null;
            let videoPreviewContent = null;
            let param1Content = null;
            let param2Content = null;
            let referenceMaxExerciseContent = null;
            let reportingExerciseContent = null;
            if (isEditable) {
                videoContent = (
                    <input
                        type="text"
                        value={exercise.video_url}
                        placeholder="Enter a youtube or vimeo url"
                        onChange={this.handleChange.bind(this, 'video_url')}
                    />
                );
                if (exercise.video_url != '' || this.state.video_url != '') {
                    videoPreviewContent = this.getVideoPlayer(
                        exercise.video_url || this.state.video_url
                    );
                } else {
                    videoPreviewContent = this.getNoVideoContent();
                }

                param1Content = (
                    <DropSimple
                        name="parameter-one"
                        options={paramTypes}
                        value={exercise.param_1_type}
                        placeholder="Select Parameter"
                        labelKey="title"
                        valueKey="id"
                        onChange={this.handleParameterChange.bind(this, '1')}
                        onOpen={this.lockEvents.bind(this)}
                        disableButtons={this.disableButtons.bind(this)}
                    />
                );
                param2Content = (
                    <DropSimple
                        name="parameter-one"
                        options={paramTypes}
                        value={exercise.param_2_type}
                        placeholder="Select Parameter"
                        labelKey="title"
                        valueKey="id"
                        onChange={this.handleParameterChange.bind(this, '2')}
                        onOpen={this.lockEvents.bind(this)}
                        disableButtons={this.disableButtons.bind(this)}
                    />
                );
                referenceMaxExerciseContent = (
                    <DropSimple
                        name="reference-max"
                        options={this.props.referenceMaxExercises}
                        value={
                            exercise.reference_max_exercise_id
                                ? _.find(this.props.referenceMaxExercises, {
                                      id: exercise.reference_max_exercise_id
                                  })
                                : null
                        }
                        onOpen={this.scrollToBottom.bind(this)}
                        placeholder="Select Reference Max Exercise"
                        labelKey="title"
                        valueKey="id"
                        onChange={this.handleReferenceMaxExerciseChange.bind(
                            this
                        )}
                        disableButtons={this.disableButtons.bind(this)}
                    />
                );
                reportingExerciseContent = (
                    <DropSimple
                        name="reporting-exercise"
                        options={this.props.reportingExercises}
                        value={
                            exercise.trainheroic_reference_exercise_id
                                ? _.find(this.props.reportingExercises, {
                                      id:
                                          // eslint-disable-next-line
                                          exercise.trainheroic_reference_exercise_id
                                  })
                                : null
                        }
                        disableButtons={this.disableButtons.bind(this)}
                        onOpen={this.scrollToBottom.bind(this)}
                        placeholder="Select Track As Exercise"
                        labelKey="title"
                        valueKey="id"
                        onChange={this.handleReportingExerciseChange.bind(this)}
                    />
                );
            } else {
                let param1 = exercise.param_1_type;
                let param2 = exercise.param_2_type;
                videoContent = exercise.video_url
                    ? this.getVideoPlayer(exercise.video_url)
                    : this.getNoVideoContent();
                if (exercise) {
                    if (this.props.video_url || exercise.video_url) {
                        videoPreviewContent = this.getVideoPlayer(
                            this.props.video_url || exercise.video_url
                        );
                    } else {
                        videoPreviewContent = this.getNoVideoContent();
                    }
                }
                param1Content = (
                    <p>
                        {param1
                            ? _.find(paramTypes, { id: param1 }).title
                            : '-'}
                    </p>
                );
                param2Content = (
                    <p>
                        {param2
                            ? _.find(paramTypes, { id: param2 }).title
                            : '-'}
                    </p>
                );
                referenceMaxExerciseContent = (
                    <p>
                        {exercise.reference_max_exercise_id
                            ? _.find(this.props.referenceMaxExercises, {
                                  id: exercise.reference_max_exercise_id
                              }).title
                            : 'No reference max'}
                    </p>
                );
                reportingExerciseContent = (
                    <p>
                        {exercise.trainheroic_reference_exercise_id
                            ? _.find(this.props.reportingExercises, {
                                  id: exercise.trainheroic_reference_exercise_id
                              }).title
                            : 'No track as exercise'}
                    </p>
                );
            }
            let referenceMaxToolTip =
                'When loads are prescribed in %, ' +
                'the working max of this exercise is referenced.';
            let reportingExerciseToolTip =
                'Data logged for your exercise will effect ' +
                'the history, PRs, working maxes, and goals ' +
                'for the selected TrainHeroic exercise.';
            return {
                parameters: (
                    <div className="input-group has-icon">
                        <label>Default Parameters</label>
                        <div className="layout-row">
                            <div className="select-container">
                                <div className="parameter-icon-label">
                                    <i className="mdi mdi-grid" />
                                    <div className="drops">
                                        <div>
                                            <span>Parameter 1</span>
                                        </div>
                                    </div>
                                </div>
                                {param1Content}
                                <span className="required-text">Required</span>
                            </div>
                            <div className="select-container">
                                <div className="parameter-icon-label">
                                    <i className="mdi mdi-grid" />
                                    <div className="drops">
                                        <div>
                                            <span>Parameter 2</span>
                                        </div>
                                    </div>
                                </div>
                                {param2Content}
                            </div>
                        </div>
                    </div>
                ),
                video: (
                    <div className="input-group has-icon">
                        <div className="layout-row layout-align-start-center">
                            <i className="mdi mdi-video" />
                            {videoContent}
                        </div>
                        <div className="layout-row layout-align-start-center">
                            {videoPreviewContent}
                        </div>
                    </div>
                ),
                referenceMax: (
                    <div className="input-group">
                        <label>Reference Max (optional)</label>
                        <Tooltip title={referenceMaxToolTip}>
                            <i
                                className="mdi mdi-information info-icon
                                mdi-18px"
                                place="top"
                            />
                        </Tooltip>
                        {referenceMaxExerciseContent}
                    </div>
                ),
                trackAs: (
                    <div className="input-group">
                        <label>Track As (optional)</label>
                        <Tooltip title={reportingExerciseToolTip}>
                            <i
                                className="mdi mdi-information info-icon
                                mdi-18px"
                                place="top"
                            />
                        </Tooltip>
                        {reportingExerciseContent}
                    </div>
                )
            };
        }
    }

    render() {
        Console.render('designer.ExerciseCreateEdit');
        let exercise = Object.keys(this.state).length
            ? this.state
            : this.props.exercise;
        let isEditable =
            exercise.can_edit === 1 || exercise.can_edit === null
                ? true
                : false;
        let sidenavHeader = null;
        let cancelLabel = 'Cancel';
        let titleContent = null;
        let tagsContent = [];
        let pointsContent = null;
        let saveButton = null;
        let titleContentError = null;
        if (isEditable) {
            cancelLabel = 'Cancel';
            titleContent = (
                <React.Fragment>
                    <TextField
                        id="title"
                        label="Title"
                        autoFocus
                        fullWidth
                        value={this.state.title}
                        onChange={ev => this.handleChange('title', ev)}
                        margin="normal"
                    />
                    <FormHelperText sx={{ color: 'text.secondary' }}>
                        Required
                    </FormHelperText>
                </React.Fragment>
            );

            titleContentError = this.state.titleUsed ? (
                <p className="error-label">This name is already used</p>
            ) : null;
            tagsContent = (
                <Drop
                    name="exercise-tags"
                    value={exercise.tags}
                    multi={true}
                    options={this.props.tags}
                    labelKey="title"
                    valueKey="id"
                    placeholder="Select tags or type your own"
                    onChange={this.handleChangeTags.bind(this)}
                    onNewOptionClick={this.onNewCircuitExerciseTag.bind(this)}
                    onOpen={this.scrollToBottom.bind(this)}
                    disableButtons={this.disableButtons.bind(this)}
                />
            );
            const placeholder =
                'Assist your athletes with tips about how ' +
                'to perform this movement';
            pointsContent = (
                <TextArea
                    value={this.state.points_of_performance}
                    count={true}
                    max={MAX_EXERCISE_POINTS_OF_PERFORMANCE_LENGTH}
                    blurCallback={this.handleChange.bind(
                        this,
                        'points_of_performance'
                    )}
                    placeholder={placeholder}
                />
            );
            saveButton = (
                <Button
                    color="primary"
                    variant="raised"
                    disabled={
                        exercise.title === '' ||
                        this.state.titleUsed ||
                        (!this.state.param_1_type && !exercise.id)
                    }
                    onClick={this.handleSave.bind(this)}
                >
                    Save Exercise
                </Button>
            );
        } else {
            titleContent = <p>{exercise.title}</p>;
            tagsContent =
                exercise.tags && exercise.tags.length ? (
                    exercise.tags.map(t => <MDTag key={`${t.id}`} tag={t} />)
                ) : (
                    <p>
                        <em>No tags available</em>
                    </p>
                );
            pointsContent = this.state.points_of_performance ? (
                <pre>{this.state.points_of_performance}</pre>
            ) : (
                <p>
                    <em>No data available</em>
                </p>
            );
        }
        const className =
            'create-dialog create-edit-exercise-dialog layout-column';

        const workoutItems = this.workoutItems(exercise.eType);
        if (workoutItems === undefined) {
            return null;
        }
        return (
            <div className={className}>
                {sidenavHeader}
                <div className="dialog-body">
                    <div className="input-group">
                        {titleContent}
                        {titleContentError}
                    </div>
                    {workoutItems.parameters}
                    {workoutItems.video}
                    <div className="input-group has-icon">
                        <label>Points of Performance (optional)</label>
                        <div className="layout-row">
                            <i className="mdi mdi-format-list-bulleted" />
                            {pointsContent}
                        </div>
                    </div>
                    <div className="tags input-group">
                        <label>Tags (optional)</label>
                        {tagsContent}
                    </div>
                    {workoutItems.referenceMax}
                    {workoutItems.trackAs}
                    <div
                        style={{ float: 'left', clear: 'both' }}
                        ref={el => {
                            this.bottomDrawer = el;
                        }}
                    />
                </div>
                <div className="dialog-footer">
                    <Button
                        onClick={this.handleClose.bind(this)}
                        disabled={this.state.disableButtons}
                    >
                        {cancelLabel}
                    </Button>
                    <Typography
                        variant="title"
                        color="inherit"
                        className="flex"
                    />
                    {saveButton}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/ExerciseCreateEdit.jsx